
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import formatPhoneNumber from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  DistrictFieldRules,
  getFieldRulesForDistrict,
  formatStoredPhoneForDisplay,
} from "@/app/infrastructures/misc/common-library/MalaysiaDistrictFieldRules";

class Props {
  detailData = prop<any>({
    type: Object,
    required: true
  });
  districtFieldRules = prop<DistrictFieldRules>({
    type: Object,
    default: () => getFieldRulesForDistrict(null, "partner")
  });
}

@Options({
  components: {
    Title
  },
  props: {
    detailData: {
      type: Object,
      required: true
    }
  }
})
export default class DetailContactInformation extends Vue.with(Props) {
  formatPhoneDisplay(phone: string) {
    if (!phone.startsWith("+")) {
      phone = "+" + phone;
    }
    return formatPhoneNumber(
      phone,
      AccountController.accountData?.country_code
    );
  }

  get contacts() {
    return this.detailData.partnerContactPhoneNumber
      .map((key: any) => key.no)
      .toString();
  }
  formattedContactPhone(raw: string) {
    return formatStoredPhoneForDisplay(raw, this.districtFieldRules);
  }
}
